import {
  faArrowLeft,
  faArrowRight,
  faEye,
  faCog,
  faCopy,
  faTimes,
  faArrowsAltV,
  faCheckCircle,
  faTimesCircle,
  faComment,
  faComments,
  faUser,
  faAngleUp,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faEdit,
  faCircle,
  faCheck,
  faBars,
  faPlus,
  faSearch,
  faTrashAlt,
  faList,
  faListAlt,
  faChevronRight,
  faClock,
  faExternalLinkAlt,
  faFile,
  faPlayCircle,
  faCertificate,
  faUsers,
  faHistory,
  faGraduationCap,
  faFolderTree,
  faImage,
  faExclamationCircle,
  faShareNodes,
  faLock,
  faCircleExclamation,
  faXmark,
  faRotateRight,
  faCartShopping
} from '@fortawesome/free-solid-svg-icons';

export default [
  faArrowLeft,
  faArrowRight,
  faEye,
  faCog,
  faCopy,
  faTimes,
  faArrowsAltV,
  faCheckCircle,
  faTimesCircle,
  faComment,
  faComments,
  faUser,
  faAngleUp,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faEdit,
  faCircle,
  faCheck,
  faBars,
  faPlus,
  faSearch,
  faTrashAlt,
  faList,
  faListAlt,
  faChevronRight,
  faClock,
  faExternalLinkAlt,
  faFile,
  faPlayCircle,
  faCertificate,
  faUsers,
  faHistory,
  faGraduationCap,
  faFolderTree,
  faImage,
  faExclamationCircle,
  faShareNodes,
  faLock,
  faCircleExclamation,
  faXmark,
  faRotateRight,
  faCartShopping
];
